import React from 'react';
import './Journey.css';
import { FaApple } from 'react-icons/fa';
import { TbDeviceMobile, TbChartBar } from 'react-icons/tb';
import { LuGraduationCap, LuTrophy } from 'react-icons/lu';

const timeline = [
  {
    period: '2025 / 2026',
    role: 'iOS Developer',
    company: 'Apple Developer Academy',
    icon: <FaApple />,
    accent: 'apple',
    points: [
      'Shipped 3 iOS apps end-to-end, from discovery to App Store and TestFlight.',
      'Built features with Foundation Models, Apple Intelligence and Core ML for on-device GenAI.',
      'Used Claude Code, multi-agent workflows, SDD and Harness Engineering to prototype faster.',
      'Validated GenAI, computer vision and multimodal POCs in collaborative teams.',
    ],
    tags: ['Swift 6', 'SwiftUI', 'Foundation Models', 'Core ML', 'Claude Code'],
  },
  {
    period: 'Sep 2025 / Feb 2026',
    role: 'QA Mobile Intern',
    company: 'Meta IT',
    icon: <TbDeviceMobile />,
    accent: 'ai',
    points: [
      'Automated mobile validation flows with Python, Robot Framework and Selenium.',
      'Built and maintained automation pipelines to boost operational efficiency.',
      'Bridged technical and business teams to align requirements.',
      'Validated APIs and quality metrics with TestRail, Postman, PostgreSQL and Android Studio.',
    ],
    tags: ['Python', 'Robot Framework', 'Selenium', 'PostgreSQL', 'Postman'],
  },
  {
    period: 'Feb 2024 / Feb 2025',
    role: 'Business Intelligence Intern',
    company: 'Pieralisi Circular Thinking',
    icon: <TbChartBar />,
    accent: 'backend',
    points: [
      'Developed automations with Python, VBA and the Power Platform.',
      'Structured and documented flows for scalability and reproducibility.',
      'Prioritized high-impact operational solutions.',
      'Worked closely with internal stakeholders to translate needs into pipelines.',
    ],
    tags: ['Python', 'Power Platform', 'VBA', 'Automation', 'BI'],
  },
];

const highlights = [
  {
    icon: <LuTrophy />,
    title: 'NEXT FIAP Finalist',
    description: 'Two-time finalist (2024 and 2025) at FIAP\'s innovation showcase.',
  },
  {
    icon: <LuGraduationCap />,
    title: 'AI/ML & GenAI Certified',
    description: 'Apple Developer Academy and IBM, applied GenAI in software development.',
  },
];

const Journey = () => {
  return (
    <section id="journey">
      <h5>Career</h5>
      <h2>Experience</h2>

      <div className='container journey__container'>
        <div className='journey__timeline'>
          {timeline.map((item, idx) => (
            <article key={idx} className={`journey__item journey__item--${item.accent}`}>
              <div className='journey__marker'>
                <span className='journey__icon'>{item.icon}</span>
                {item.current && <span className='journey__pulse' />}
              </div>

              <div className='journey__content'>
                <div className='journey__head'>
                  <span className='journey__period'>{item.period}</span>
                  {item.current && <span className='journey__badge'>Current</span>}
                </div>
                <h3 className='journey__role'>{item.role}</h3>
                <p className='journey__company'>{item.company}</p>

                <ul className='journey__points'>
                  {item.points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>

                <div className='journey__tags'>
                  {item.tags.map((t) => (
                    <span key={t} className='journey__tag'>{t}</span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className='journey__highlights'>
          {highlights.map((h, i) => (
            <article key={i} className='journey__highlight'>
              <span className='journey__highlight-icon'>{h.icon}</span>
              <div>
                <h4>{h.title}</h4>
                <p>{h.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Journey;
